import { IonButton, IonContent, IonPage, useIonModal } from "@ionic/react";

import { useHistory, useRouteMatch } from "react-router";
import Header from "../components/Header";
import BotListComponent from "../components/BotList";
import { ReactComponent as BotIcon } from "../assets/graphics/smart_toy.svg";
import { SetupBot } from "./SetupBot";
import { useBotsStore } from "../stores/bots.store";

const BotListPage: React.FC = () => {
  // get type and mode from path /botList/:mode/:filter
  const mode = useRouteMatch<{ mode: string }>().params.mode;
  const filter = useRouteMatch<{ filter: string }>().params.filter;
  const history = useHistory();
  const [presentSetupBot, dismissSetupBot] = useIonModal(SetupBot, {
    mode,
    navigateTo: (path: string) => history.push(path),
    onDismiss: () => dismissSetupBot()
  });

  const liveBots = useBotsStore(state =>
    state.bots.filter(b => b.mode === "live" && b.active)
  );
  return (
    <IonPage>
      <Header
        title={`${mode === "simulation" ? "Simulated" : mode} Bots`}
        back={true}
      />
      <IonContent>
        <div className="flex items-center m-2 rounded-t-lg bg-primary-70 p-4 justify-between max-w-lg mx-auto">
          <div className="flex items-center">
            <div
              className={`w-fit p-2 mr-2 rounded-lg ${
                filter === "active"
                  ? "bg-[#0aff95]"
                  : filter === "past"
                  ? "bg-[#ff6161]"
                  : "bg-[#fbff0a]"
              }`}
            >
              <BotIcon className="no-fill" />
            </div>
            <div className="text-lg ml-2 font-semibold text-white capitalize">
              {filter} - {mode === "simulation" ? "simulated" : mode} Bots
            </div>
          </div>
          <IonButton
            color="primary"
            disabled={liveBots.length >= 1}
            onClick={() => {
              presentSetupBot();
            }}
          >
            Add Bot +
          </IonButton>
        </div>
        <BotListComponent mode={mode} filter={filter} />
      </IonContent>
    </IonPage>
  );
};

export default BotListPage;
